<template>
  <div class="l-block__detail">
    <TitleSub level="h3">
      <span class="title">施策を行う</span>
    </TitleSub>

    <div>
      <p class="l-block__text">
        リライトを行う場合は「コンテンツ立案」で上位サイトとの比較ができます。<br />
        タイトル変更の際の注意点については
        <a
          href="https://support.searchwrite.jp/hc/ja/articles/4404901682831-%E3%82%BF%E3%82%A4%E3%83%88%E3%83%AB%E3%82%92%E5%A4%89%E6%9B%B4%E3%81%97%E3%81%9F%E3%81%84"
          class="l-side-logo__link c-link--blank"
          target="_blank"
        >
          こちら
        </a>
        の記事をご覧ください。
      </p>

      <!-- 施策: TODO -->
      <TitleSub level="h4" class="l-mt-8">
        <span class="title">「TODO」タスクのコンテンツ</span>
      </TitleSub>

      <div class="c-table c-table--todo">
        <div class="c-table__header">
          <div class="items">
            <div class="item_header_keyword">
              キーワード（<span :class="{ active: tasksCountTodo > 0 }"
                >{{ tasksCountTodo }}件</span
              >）
            </div>
            <div class="item_header_link">リンク</div>
            <div class="item_header_category">施策内容</div>
            <div class="item_header_button"></div>
          </div>
        </div>

        <div class="c-table__body">
          <div v-if="isLoading">
            <div class="items">
              <Loading variant="inline" />
            </div>
          </div>

          <template v-else-if="tasksCountTodo === 0">
            <Error variant="inline">
              <template slot="title">
                タスクがありません。
              </template>
              <p>
                リライトまたは、タイトル変更タスクを登録すると表示されます。
              </p>
            </Error>
          </template>

          <template v-else>
            <ListItemRefineContentExcuteTaskTodo
              v-for="item in sortedItemsTodo"
              :key="item.id"
              :item="item"
              :project="project"
            />
          </template>
        </div>
      </div>

      <!-- 施策: 進行中 -->
      <TitleSub level="h4" class="l-mt-8">
        <span class="title">「進行中」タスクのコンテンツ</span>
      </TitleSub>

      <div class="c-table c-table--doing">
        <div class="c-table__header">
          <div class="items">
            <div class="item_header_keyword">
              キーワード（<span :class="{ active: tasksCountDoing > 0 }"
                >{{ tasksCountDoing }}件</span
              >）
            </div>
            <div class="item_header_link">リンク</div>
            <div class="item_header_category">施策内容</div>
            <div class="item_header_button"></div>
          </div>
        </div>

        <div class="c-table__body">
          <div v-if="isLoading">
            <div class="items">
              <Loading variant="inline" />
            </div>
          </div>

          <template v-else-if="tasksCountDoing === 0">
            <Error variant="inline">
              <template slot="title">
                タスクがありません。
              </template>
              <p>
                リライトまたは、タイトル変更タスクの
                ステータスを「進行中」に変更すると表示されます。
              </p>
            </Error>
          </template>

          <template v-else>
            <ListItemRefineContentExcuteTaskDoing
              v-for="item in sortedItemsDoing"
              :key="item.id"
              :item="item"
              :project="project"
              @taskCompleteModalOpen="openModalTaskComplete"
            />
          </template>
        </div>
      </div>
    </div>
    <ModalFormRefineTaskComplete
      v-if="modal.isActive"
      :project="project"
      :item="modal.item"
      @close="closeModalTaskComplete"
      @openModalRegisterObservationKeyword="openModalRegisterObservationKeyword"
      @completeRefineTask="completeRefineTask"
    />
    <ModalFormRegisterObservationKeyword
      v-if="modalObservationKeyword.isActive"
      :project="project"
      :item="modalObservationKeyword.item"
      @close="closeModalObservationKeyword"
    />
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import ListItemRefineContentExcuteTaskTodo from '@/components/dashboard/ListItemRefineContentExcuteTaskTodo';
import ListItemRefineContentExcuteTaskDoing from '@/components/dashboard/ListItemRefineContentExcuteTaskDoing';
import ModalFormRefineTaskComplete from '@/components/dashboard/ModalFormRefineTaskComplete';
import ModalFormRegisterObservationKeyword from '@/components/dashboard/ModalFormRegisterObservationKeyword';
import utils from '@/utils';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    tasksCount: {
      type: Number,
      required: true
    },

    tasksTodo: {
      type: Array,
      required: true
    },
    tasksCountTodo: {
      type: Number,
      required: true
    },

    tasksDoing: {
      type: Array,
      required: true
    },
    tasksCountDoing: {
      type: Number,
      required: true
    },

    isLoading: {
      type: Boolean,
      required: true
    }
  },

  components: {
    TitleSub,
    Loading,
    Error,
    ListItemRefineContentExcuteTaskTodo,
    ListItemRefineContentExcuteTaskDoing,
    ModalFormRefineTaskComplete,
    ModalFormRegisterObservationKeyword
  },

  created() {
    this.$store.dispatch('task/getTaskSolutions');
  },

  data() {
    return {
      modal: {
        item: {},
        isActive: false
      },
      modalObservationKeyword: {
        item: {},
        isActive: false
      },
      params: {
        sort: {
          name: 'executionDate',
          orderby: 'asc',
          type: 'date'
        },
        sortTodo: {
          name: 'createdAt',
          orderby: 'asc',
          type: 'date'
        }
      }
    };
  },

  methods: {
    completeRefineTask(task) {
      this.$emit('completeRefineTask', task);
    },
    openModalTaskComplete(item) {
      this.modal.isActive = true;
      this.modal.item = item;
    },
    closeModalTaskComplete() {
      this.modal.item = {};
      this.modal.isActive = false;
    },
    openModalRegisterObservationKeyword(item) {
      this.modalObservationKeyword.isActive = true;
      this.modalObservationKeyword.item = item;
    },
    closeModalObservationKeyword() {
      this.modalObservationKeyword.isActive = false;
      this.modalObservationKeyword.item = {};
    }
  },

  computed: {
    sortedItemsTodo() {
      return utils.sort(
        this.tasksTodo,
        this.params.sortTodo.type,
        this.params.sortTodo.orderby,
        this.params.sortTodo.name
      );
    },
    sortedItemsDoing() {
      return utils.sort(
        this.tasksDoing,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    }
  }
};
</script>
